import React, { ChangeEvent, KeyboardEvent, memo, ReactNode, SyntheticEvent, useCallback } from 'react'
import cn from 'classnames'
import noop from 'lodash/noop'

import s from './Input.module.less'

interface IProps {
  onChange: (value: string) => void
  placeholder: string
  value: string
  autoFocus?: boolean
  className?: string
  desktopParentElement?: ReactNode
  disabled?: boolean
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  testId?: string
}

export const Input = ({
  autoFocus = false,
  className,
  placeholder,
  value,
  disabled,
  onChange,
  onKeyDown = noop,
  desktopParentElement,
  testId
}: IProps) => {
  const handleClick = useCallback((e: SyntheticEvent<HTMLSpanElement>) => {
    e.nativeEvent.stopImmediatePropagation()
    e.stopPropagation()
  }, [])

  const handleChange = useCallback(
    ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      if (!disabled) {
        onChange(value)
      }
    },
    [disabled, onChange]
  )

  return (
    <input
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
      className={cn(s.suggestInput, { [s.suggestInput_disabled]: disabled }, className)}
      data-test-id={testId}
      // @ts-ignore
      onBlur={() => desktopParentElement?.classList.remove('focused')}
      onChange={handleChange}
      onClick={handleClick}
      // @ts-ignore
      onFocus={() => desktopParentElement?.classList.add('focused')}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      value={value}
    />
  )
}

export const InputMemo = memo(Input) as typeof Input
